import React from 'react';
import { Mail, ExternalLink } from 'lucide-react';
import './Footer.css';

// Single slim strip (owner ask 2026-07-26) — the old four-column footer was collapsed to one row:
// copyright · contact email · a link back to the corporate home page. Brand tokens only, wraps
// gracefully on mobile.
const Footer = () => (
  <footer className="footer">
    <div className="container footer-strip">
      <p className="footer-copyright">© {new Date().getFullYear()} ADEL Group. All rights reserved.</p>
      <div className="footer-actions">
        <a className="footer-mail" href="mailto:info@adelgroups.com">
          <Mail size={16} aria-hidden="true" /> info@adelgroups.com
        </a>
        <a className="footer-home" href="https://adelgroups.com" target="_blank" rel="noopener noreferrer">
          Visit home page <ExternalLink size={15} aria-hidden="true" />
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
